<template>
  <v-dialog v-model="dialog" :max-width="options.width" @keyup.esc="cancel">
    <v-card>
      <v-toolbar color="primary" dense flat>
        <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-show="!!message">{{ message }}</v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn color="grey" flat="flat" @click="cancel">{{ $gettext('Cancel') }}</v-btn>
        <v-btn
          color="primary darken-1"
          flat="flat"
          @click="confirm"
        >{{ $gettext('Confirm') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Confirm",
  data() {
    return {
      dialog: false,
      resolve: null,
      message: null,
      title: null,
      options: {
        color: "primary",
        width: 300
      }
    };
  },
  methods: {
    open(title, message, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);

      return new Promise(resolve => {
        this.resolve = resolve;
      });
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
    confirm() {
      this.resolve(true);
      this.dialog = false;
    }
  }
};
</script>
